import { useQueries } from "@tanstack/react-query";
import { getMethodsInputs } from "../../api/methodsInput";
import { MethodsInput } from "../../types/model/methodsInput";

export const useCapturesMethodsInputs = (captureIds: number[]) => {
  const queries = useQueries({
    queries: captureIds.map((id) => ({
      queryKey: ["methodsInputs", id],
      queryFn: () => getMethodsInputs(id),
    })),
  });

  const methodsInputsByCapture = Object.fromEntries(
    captureIds.map((id, i) => [id, queries[i].data ?? []]),
  ) as Record<number, MethodsInput[]>;

  return {
    methodsInputsByCapture,
    isPending: queries.some((q) => q.isPending),
  };
};